import React from 'react';
import { Link } from 'react-router-dom';

const TermsConditions = () => (
  <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
    <header className="bg-[#0a1a3d] py-5">
      <div className="max-w-[900px] mx-auto px-4 sm:px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <div className="w-8 h-8 bg-[#0E47B0] rounded-md flex items-center justify-center">
            <span className="text-white font-bold text-sm">L</span>
          </div>
          <span className="text-white font-bold text-lg">Lex Recupero™</span>
        </Link>
        <Link to="/" className="text-white/60 hover:text-white text-sm no-underline transition-colors">&larr; Torna alla home</Link>
      </div>
    </header>

    <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-[32px] font-bold text-[#1a1a2e] mb-4">Termini e Condizioni d'Uso</h1>
      <p className="text-sm text-[#4a4a6a] mb-2">Lex Recupero™ Studio Legale &mdash; Sede Italia</p>
      <p className="text-sm text-[#4a4a6a] mb-6">Ultimo aggiornamento: Aprile 2026</p>

      {/* Disclaimer prominente */}
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-8">
        <p className="text-[14px] text-amber-800 leading-[1.7]">
          <strong>Disclaimer importante:</strong> Le informazioni presenti su questo sito hanno finalità esclusivamente informative e non costituiscono consulenza legale. La compilazione del modulo di contatto non crea un rapporto professionale avvocato-cliente. Nessun risultato legale può essere garantito. Ogni caso viene valutato individualmente sulla base dei fatti e della documentazione disponibile.
        </p>
      </div>

      <div className="space-y-6 text-[15px] text-[#4a4a6a] leading-[1.8]">
        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">1. Accettazione dei termini</h2>
          <p>Utilizzando il sito web Lex Recupero™, accetti integralmente i presenti Termini e Condizioni d'Uso. Se non accetti questi termini, ti preghiamo di non utilizzare il sito. L'uso continuato del sito dopo eventuali modifiche ai termini costituisce accettazione delle modifiche stesse.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">2. Descrizione del servizio e limitazioni</h2>
          <p>Lex Recupero™ è uno studio legale che offre una valutazione legale preliminare gratuita per persone che desiderano comprendere le possibili opzioni legali disponibili in situazioni complesse relative a investimenti online, piattaforme digitali e intermediari finanziari.</p>
          <p className="mt-3">Il sito web e il modulo di contatto <strong>non costituiscono</strong>:</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Consulenza legale specifica per il caso individuale</li>
            <li>Prestazione professionale di assistenza legale</li>
            <li>Garanzia di recupero di somme investite o di qualsiasi risultato finanziario</li>
            <li>Promessa di esito specifico in qualsiasi procedimento legale</li>
            <li>Servizio di consulenza finanziaria o di investimento</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">3. Nessuna garanzia di risultato</h2>
          <p>Lex Recupero™ <strong>non garantisce</strong> alcun risultato specifico in relazione ai casi esaminati. I risultati di qualsiasi procedimento legale dipendono da molteplici fattori, tra cui la documentazione disponibile, la normativa applicabile, la giurisdizione competente e le specifiche circostanze del caso.</p>
          <p className="mt-3">Qualsiasi indicazione fornita dal nostro studio in fase di valutazione preliminare costituisce un parere professionale soggetto alle informazioni disponibili al momento, e non può essere inteso come garanzia di esito.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">4. Modulo di contatto e raccolta dati</h2>
          <p>La compilazione del modulo di contatto sul sito serve a raccogliere informazioni preliminari necessarie per valutare se è possibile fornire assistenza legale. La compilazione non costituisce incarico professionale e non crea alcun obbligo tra le parti fino alla stipula di un mandato professionale scritto.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">5. Informazioni sul sito &mdash; solo scopo informativo</h2>
          <p>Tutti i contenuti presenti sul sito (testi, immagini, esempi, sezioni informative) hanno finalità esclusivamente informative e divulgative. Non devono essere intesi come pareri legali specifici, raccomandazioni di azione legale o garanzie di alcun tipo.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">6. Proprietà intellettuale</h2>
          <p>Tutti i contenuti del sito, inclusi testi, grafiche, loghi e struttura visiva, sono protetti dalle leggi sul diritto d'autore e sono di proprietà di Lex Recupero™ Studio Legale. Non è consentita la riproduzione senza autorizzazione scritta.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">7. Limitazione di responsabilità</h2>
          <p>Lex Recupero™ non sarà responsabile per eventuali danni diretti, indiretti o consequenziali derivanti dall'utilizzo del sito o dall'affidamento alle informazioni presenti nelle pagine. L'utente è l'unico responsabile delle decisioni prese sulla base dei contenuti del sito.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">8. Normativa applicabile e foro competente</h2>
          <p>I presenti termini sono regolati dalla legislazione italiana vigente. Per eventuali controversie relative all'utilizzo del sito sarà competente il Foro di Roma (o quello del luogo di residenza del consumatore, ai sensi del Codice del Consumo).</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">9. Modifiche ai termini</h2>
          <p>Ci riserviamo il diritto di modificare i presenti Termini e Condizioni in qualsiasi momento. Le modifiche saranno effettive dalla data di pubblicazione sul sito. Si raccomanda di consultare periodicamente questa pagina.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-[#1a1a2e] mb-3">10. Contatti</h2>
          <p>Per qualsiasi questione relativa ai presenti termini: <a href="mailto:info@lexrecupero.it" className="text-[#0E47B0] hover:underline">info@lexrecupero.it</a></p>
        </section>
      </div>
    </div>
  </div>
);

export default TermsConditions;
